import { Typography } from "@material-ui/core";
import { Box, Grid, Tooltip } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CommonUtil from "../../Util/CommonUtils";
import HeaderToolbar from "../../components/HeaderToolbar";
import { getUserDetails } from "../../slices/Dealer/DealerSlice";
import { purchasedProducts } from "../../slices/ProductSlice/ProductSlice";

function CustomersReportView(props) {
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const companyId = localStorage.getItem("companyId");
  const [hardwareDevices, setHardwareDevices] = useState([]);
  const [purchasedProductsList, setPurchasedProductsList] = useState([]);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [dateFormat, setDateFormat] = useState(
    companySettings?.adminAndDealerDateFormat
  );

  const handleTextOverflow = (text) => {
    if (text && text.length > 35) {
      return text.substring(0, 25) + "...";
    } else {
      return text;
    }
  };
  const emailValue = props.location.state.email;

  useEffect(() => {
    const fetchData = async () => {
      loadPurchasedProducts();
      loadUserDetails();
    };

    fetchData();
  }, [
    props.location?.state?.id,
    props.location?.state?.dealerId,
    emailValue,
    companyId,
  ]);

  const loadPurchasedProducts = async () => {
    try {
      const res = await dispatch(
        purchasedProducts(props.location?.state?.id)
      ).unwrap();

      if (res.code === "MSGS4000") {
        const mergedData = res.data.reduce((acc, item) => {
          const existingItem = acc.find(
            (p) => p.stripeProductId === item.stripeProductId
          );

          if (existingItem) {
            existingItem.quantity += item.quantity;
          } else {
            acc.push({ ...item });
          }

          return acc;
        }, []);

        setHardwareDevices(mergedData);
        setPurchasedProductsList(mergedData);
        return mergedData;
      } else {
        console.error("Unexpected code:", res.code);
        return [];
      }
    } catch (error) {
      console.error("Error loading purchased products:", error);
      return [];
    }
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "DD-MM-YYYY":
        return "dd-MM-yyyy HH:mm";
      case "MM-DD-YYYY":
        return "MM-dd-yyyy HH:mm";
      case "YYYY-MM-DD":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };
  const loadUserDetails = async () => {
    try {
      const data = await dispatch(getUserDetails(emailValue)).unwrap();
      if (data.code === "UASI0033") {
        setFirstName(data.data.firstName);
        setLastName(data.data.lastName);
      } else {
        console.error("Unexpected code:", data.code);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  return (
    <>
      <HeaderToolbar title={t("VIEWPAGECUSTOMERREPORT")} back_button={true} />
      <Box
        sx={{
          height: "80vh", // Full viewport height
          overflowY: "auto", // Enable scrolling only inside this container
          overflowX: "hidden", // No horizontal scroll
          paddingTop: "20px",
          "&::-webkit-scrollbar": {
            width: "2px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
          },
        }}
      >
        <Grid container lg={12} md={12} item sx={{ bgcolor: "white" }}>
          <Grid item padding={2}>
            <Avatar
              alt="Customer Avatar"
              src={props.location.state.imagePreSignedURL || ""}
              style={{ height: "180px", width: "180px", marginLeft: "40px" }}
            />
          </Grid>

          {/* First Column */}
          <Grid
            item
            xs
            zeroMinWidth
            style={{
              marginLeft: "20px",
              marginTop: "20px",
              borderRight: "3px solid #E1E9F5",
            }}
          >
            {[
              { label: t("DEALERFIRSTNAME"), value: firstName },
              { label: t("DEALERLASTNAME"), value: lastName },
              { label: t("COMMON042"), value: props.location.state.email },
              {
                label: t("VIEWPAGEMOBLIENUMBER"),
                value: props.location.state.phone,
              },
              {
                label: t("DEALERCOMPANYNAME"),
                value: props.location.state.name,
              },
              { label: t("CUSTDATABLE04"), value: `${firstName} ${lastName}` },
            ].map((item, index) => (
              <Grid
                container
                wrap="nowrap"
                key={index}
                style={{ marginTop: "10px" }}
              >
                <Grid item xs={6}>
                  <Typography noWrap style={{ opacity: "50%" }}>
                    {item.label}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Tooltip title={item.value || ""} placement="bottom-start">
                    <Typography noWrap>{item.value || ""}</Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            ))}
          </Grid>
          {/* Second Column */}
          <Grid
            item
            xs
            zeroMinWidth
            style={{
              marginLeft: "20px",
              marginTop: "20px",
              borderRight: "3px solid #E1E9F5",
            }}
          >
            {[
              {
                label: t("LABELNAVITEMSSUBSCRIPTION"),
                value: props.location.state.subscriptionName,
              },
              {
                label: t("SELECTSUBSCRIPTIONTYPE"),
                value: props.location.state.billingCycle,
              },
              {
                label: t("CUSTDATABLE22"),
                value: props.location.state.dealerName,
              },
              {
                label: t("CUSTDATABLE20"),
                value: props.location.state.planBasePrice / 100,
              },
            ].map((item, index) => (
              <Grid
                container
                wrap="nowrap"
                key={index}
                style={{ marginTop: "10px" }}
                columnSpacing={1}
              >
                <Grid item xs={6}>
                  <Typography noWrap style={{ opacity: "50%" }}>
                    {item.label}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Tooltip title={item.value || ""} placement="bottom-start">
                    <Typography noWrap>
                      {handleTextOverflow(item.value || "")}
                    </Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            ))}
            <Grid container style={{ marginTop: "10px" }}>
              <Grid item xs={6}>
                <Typography style={{ opacity: "50%" }}>
                  {t("CUSTDATABLE38")}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography style={{ marginLeft: "5px" }}>
                  {props.location.state.subscriptionEndDate
                    ? formatDate(dateFormat) === "dd-MM-yyyy HH:mm"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.location.state.subscriptionEndDate
                          )
                        ).format("DD-MM-YYYY HH:mm")
                      : formatDate(dateFormat) === "MM-dd-yyyy HH:mm"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.location.state.subscriptionEndDate
                          )
                        ).format("MM-DD-YYYY HH:mm")
                      : formatDate(dateFormat) === "yyyy-MM-dd HH:mm"
                      ? moment(
                          CommonUtil.getLocalDateTimeInYearFormat(
                            props.location.state.subscriptionEndDate
                          )
                        ).format("YYYY-MM-DD HH:mm")
                      : ""
                    : ""}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid
            container
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              padding: "40px",
            }}
          >
            {hardwareDevices.length > 0 && (
              <>
                <Grid item xs={12}>
                  <Typography
                    variant="h6"
                    style={{
                      color: "#474A4E",
                      opacity: "0.9",
                      fontFamily: "font_semiBold",
                    }}
                  >
                    {t("PRODUCT_DETAILS")}
                  </Typography>
                </Grid>
                {hardwareDevices.map((product, index) => (
                  <Box
                    key={`hardware-${index}`}
                    position="relative"
                    style={{
                      height: "100px",
                      backgroundColor: "#F9F9F9",
                      display: "flex",
                      alignItems: "center",
                      width: "250px",
                      padding: "10px",
                      borderRadius: "8px",
                    }}
                  >
                    <Box
                      style={{
                        height: "62px",
                        width: "62px",
                        backgroundColor: "#D8D8D8",
                        borderRadius: "6px",
                        marginRight: "15px",
                        overflow: "hidden",
                      }}
                    >
                      {product.product.productImagePresignedUrl ? (
                        <img
                          src={product.product.productImagePresignedUrl}
                          alt="Product"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <Box
                          style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#E0E0E0",
                          }}
                        />
                      )}
                    </Box>
                    <Typography
                      style={{
                        color: "#474A4E",
                        fontSize: "18px",
                        fontFamily: "font_bold",
                        lineHeight: "1.2",
                      }}
                    >
                      {product.product.productName.length > 10 ? (
                        <Tooltip
                          title={product.product.productName}
                          placement="bottom-start"
                        >
                          <span>
                            {product.product.productName.substring(0, 10)}...
                          </span>
                        </Tooltip>
                      ) : (
                        <span>{product.product.productName}</span>
                      )}
                      {product.product.productModel && (
                        <>
                          <span> + </span>
                          {product.product.productModel.length > 10 ? (
                            <Tooltip
                              title={product.product.productModel}
                              placement="bottom-start"
                            >
                              <span>
                                {product.product.productModel.substring(0, 10)}
                                ...
                              </span>
                            </Tooltip>
                          ) : (
                            <span>{product.product.productModel}</span>
                          )}
                        </>
                      )}
                    </Typography>

                    <Typography
                      component="span"
                      style={{
                        fontSize: "18px",
                        color: "#226BAB",
                      }}
                    >
                      {" ("}
                      {product.quantity}
                      {")"}
                    </Typography>
                  </Box>
                ))}
              </>
            )}
          </Grid> */}
        </Grid>
      </Box>
    </>
  );
}

export default CustomersReportView;
